export const ORDER_TYPE_OPTIONS = [
    { value: 'B2B', description: 'B2B' },
    { value: 'D2C', description: 'D2C' },
    { value: 'AmazonFBA', description: 'Amazon FBA' }
];
